export const CHECK_AUTH = "checkAuth";
export const CHECK_AUTH_NEW_LOGIN = "checkAuthNewLogin"
export const CHECK_AUTH_SWITCH_ACCOUNT = "checkAuthSwitchAuth"
export const LOGIN = "login";
export const LOGIN_CODE = "loginCode";
export const LOGOUT = "logout";
export const REGISTER = "register";
export const SET_ERRORS = "errors";
export const REGISTER_ORGANIZATION = "loginOrganization";

// commercialClientDetails
export const GET_LOCATIONS = "getLocations";
